import { render } from "./FxTable.vue?vue&type=template&id=71ab7de8"
import script from "./FxTable.vue?vue&type=script&lang=js"
export * from "./FxTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__